/**
 * TOLERANCE (feature control frame) serializer — Faz 8.3. The structural
 * rows/cells model flattens into the OCS text encoding: symbol cells wrap
 * as {\Fgdt;X}, cells join with %%v, rows join with "\n" — exactly what
 * AutoCAD's AcDbFcf group-1 string carries. Legacy string-cell payloads
 * (Faz 1 placeholder) still export through the same path.
 */

import type { Entity } from '../../../../state/store';
import type { DxfWriteContext } from '../types';
import type { DxfStreamWriter } from '../DxfStreamWriter';
import { entityPrologue } from './common';
import { encodeToleranceText, type ToleranceRow } from '../../../../core/commands/toleranceModel';

export function writeToleranceEntity(w: DxfStreamWriter, ctx: DxfWriteContext, e: Entity, owner: string): void {
    const d = e.data as Record<string, any>;
    const p = (d.position as number[]) ?? [0, 0, 0];
    const rows = (Array.isArray(d.rows) ? d.rows : undefined) as ToleranceRow[] | undefined;
    // Structural model → %%v + {\Fgdt;X}; legacy flat cells → %%v join.
    const content = rows
        ? encodeToleranceText(rows)
        : ((Array.isArray(d.cells) ? d.cells : ['±0.0']) as string[]).join('%%v');
    entityPrologue(w, ctx, e, 'TOLERANCE', owner);
    w.pair(100, 'AcDbFcf');
    w.pair(3, 'Standard');
    w.pair(10, p[0] ?? 0).pair(20, p[1] ?? 0).pair(30, p[2] ?? 0);
    if (typeof d.textHeight === 'number' && d.textHeight > 0) w.pair(40, d.textHeight);
    w.pair(1, content);
}
